import {
  BellOutlined,
  LogoutOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Badge, Dropdown, Grid, message, Space } from 'antd';
import { Avatar } from 'components';
import { useSessionContext } from 'features/auth';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
import { ChangeComapnyItemModal } from 'features/Dashboard/components/modal/change-company';
import { useNotificationSeen } from 'features/Dashboard/use-cases/create-notification-seen';
import { useUserContext } from 'features/users';
import { ArrowRightLeft, Menu, User } from 'lucide-react';
import { useSideBar } from 'providers/side-bar-provider';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

import {
  StyledDropdownIcon,
  StyledHeader,
  StyledUserInfo,
  StyledUserMenuButton,
} from './header.styles';

const { useBreakpoint } = Grid;

export const Header = ({ refetch }: any) => {
  const { logOut } = useSessionContext();
  const { user, companyUser } = useUserContext();
  const userId = localStorage.getItem('userId');
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const avatarSize = 32;
  const navigate = useNavigate();
  const { toggleCollapsed, toggleNotificationCollapsed } = useSideBar();
  const [data, setData] = useState<any>('');
  const [showModal, setShowModal] = useState(false);
  const { mutate } = useNotificationSeen();

  const initial = async () => {
    try {
      const apiRes = await DashBoardApiService().GetNotificationsCount({
        CompanyId: user?.CompanyId,
      } as any);
      setData(apiRes);
    } catch (error: any) {
      message.error(error);
    }
  };
  const handleBellClick = (e: any) => {
    toggleNotificationCollapsed();
    refetch();
    if (data?.rc?.[0]?.totalCount === 0) {
      e.stopPropagation();

      return; // Exit early if count is zero
    }
    const payloadValue: any = {
      LoggedInUserId: userId,
      CompanyId: user?.CompanyId,
    };
    mutate(payloadValue, {
      onSuccess: (data1: any) => {
        if (data1?.rs == 1) {
          message.success('Notification Seen');
          initial();
        } else {
          message.error(data1?.rm);
        }
      },
    });
    // navigate('/');
    e.stopPropagation(); // Prevents event bubbling to the dropdown
  };
  useEffect(() => {
    const interval = setInterval(() => {
      initial();
    }, 10000); // 10000ms = 10 seconds

    return () => clearInterval(interval);
  }, []);

  if (!user) return null;

  return (
    <StyledHeader className='app-header shadow-md'>
      <Space className='header_title_top'>
        <img src='/partnerplus_logo.png' alt='logo' className='w-48' />
        <Menu className=' w-12 mr-3 cursor-pointer' onClick={toggleCollapsed} />
        <div className='flex items-center gap-2'>
          <div className='app-header-avatar text-xl bg-lime-500 text-white rounded-full flex items-center justify-center w-10 h-10 overflow-hidden'>
            {user?.CompanyImage ? (
              <img
                src={user?.CompanyImage}
                className='w-full h-full object-cover'
              />
            ) : (
              <User />
            )}
          </div>
          <StyledUserInfo ellipsis>
            {/* ellipsis={{ tooltip: true }} */}
            <span>Company Name: {user?.BusinessName}</span>
          </StyledUserInfo>
        </div>
      </Space>

      <div className='flex items-center justify-between drpmenu'>
        <Space className='mr-5'>
          <Badge style={{ right: '13px' }} count={data?.rc?.[0]?.totalCount}>
            <BellOutlined
              onClick={handleBellClick}
              style={{
                color: 'black',
                width: '34px',
                height: '34px',
                background: '#F3F3F3',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '15px',
              }}
            />
          </Badge>
        </Space>
        <Space className='app-header-user-wrapper'>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'accountSettings',
                  label: t('userMenu.accountSettings'),
                  icon: <SettingOutlined />,
                  onClick: () => navigate(ROUTES.ACCOUNT_SETTINGS),
                },
                {
                  key: 'logout',
                  label: t('userMenu.logOut'),
                  icon: <LogoutOutlined />,
                  onClick: logOut,
                },
                ...(companyUser?.rc?.length > 1
                  ? [
                      {
                        key: 'Company',
                        label: 'Change Company',
                        icon: (
                          <ArrowRightLeft
                            style={{
                              width: '15px',
                              color: '#545454',
                            }}
                          />
                        ),
                        onClick: () => setShowModal(true),
                      },
                    ]
                  : []),
              ],
            }}
            trigger={['click']}
            getPopupContainer={(triggerNode) =>
              triggerNode.parentNode as HTMLElement
            }
          >
            <StyledUserMenuButton
              className='app-header-user'
              ghost
              $avatarSize={avatarSize}
              aria-label={t('userMenu.toggle')}
            >
              <Avatar
                size={avatarSize}
                src={user?.ClientImage}
                className='app-header-avatar text-xl bg-lime-500 text-white rounded-full flex items-center justify-center'
              />
              <Space className='app-header-space'>
                <StyledUserInfo ellipsis>
                  {/* ellipsis={{ tooltip: true }} */}
                  {user?.Name}
                </StyledUserInfo>
              </Space>
              {screens.lg ? (
                <StyledDropdownIcon
                  style={{ marginLeft: '12px', color: '#000' }}
                />
              ) : null}
            </StyledUserMenuButton>
          </Dropdown>
          {showModal && (
            <ChangeComapnyItemModal onClose={() => setShowModal(false)} />
          )}
        </Space>
      </div>
    </StyledHeader>
  );
};
